import React, { memo, useEffect, useState } from 'react';
import {
  DialogContent,
  Dialog,
  Grid,
  Typography,
  IconButton,
  TextField,
  makeStyles,
  Button,
  CircularProgress,
  MenuItem,
  Tabs,
  Tab,
  Tooltip
} from '@material-ui/core';
import { ACCOUNT_CATEGORY_BASE_URL, OPERATIONAL_BASE_URL } from 'constants/url';
import { Close } from '@material-ui/icons';
import { DialogTitle } from 'components';
import { GREY, GREY_6, PRIMARY_MOBILE, WHITE } from 'constants/colors';
import axios from 'axios';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import ArtTrackOutlinedIcon from '@material-ui/icons/ArtTrackOutlined';
import BallotOutlinedIcon from '@material-ui/icons/BallotOutlined';
import CardTravelOutlinedIcon from '@material-ui/icons/CardTravelOutlined';
import CreateTax from './CreateTax';
import CreateAssetSale from './CreateAssetSale';
import CreateLoan from './CreateLoan';
import CreateCapitalInvestment from './CreateCapitalInvestment';
import CreateOtherIncome from './CreateOtherIncome';
import CreateSalesDeposit from './CreateSalesDeposit';

const useStyles = makeStyles({
  container: {
    marginTop: 10,
    columnGap: '1em'
  },

  iconLarge: {
    fontSize: '3.5em'
  },
  containerImage: {
    margin: '0.7em 0',
    rowGap: '0.7em'
  },
  uploadImage: {
    padding: '1em ',
    backgroundColor: GREY,
    border: '2px dashed ' + GREY_6
  },
  browser: {
    color: PRIMARY_MOBILE,
    cursor: 'pointer'
  },
  wrapperImage: {
    columnGap: '1em'
  },
  containerBoxImage: {
    position: 'relative'
  },
  image: {
    objectFit: 'contain',
    borderRadius: '0.5em',
    height: '4em'
  },
  closeImage: {
    position: 'absolute',
    top: 5,
    right: 5
  },
  closeIcon: {
    backgroundColor: 'rgba(32, 42, 61, 0.88)',
    borderRadius: '50%',
    cursor: 'pointer',
    color: WHITE
  },
  tabPanel: {
    flexGrow: 1,
    marginBottom: '20px',
    display: 'flex',

    maxWidth: 500,
    justifyContent: 'center'
  },
  tab: {
    minWidth: 'auto',
    padding: '10px',
    margin: '0 4px'
  }
});
interface Props {
  financialAccounts: AccountCategoryModel[];
  open: boolean;
  handleCloseCreate: () => void;
  reFetchData: () => void;
  handleSnackBar: (open: boolean, variant: 'success' | 'error', message: string) => void;
}

const OtherIncomeCreate = ({ handleSnackBar, financialAccounts, open, handleCloseCreate, reFetchData }: Props) => {
  const classes = useStyles();
  const source = axios.CancelToken.source();
  const cancelToken = source.token;
  const [subAccountCategories, setSubAccountCategories] = useState<AccountCategoryModel[]>([]);
  const [tab, setTab] = React.useState<number>(0);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const handleTabs = (event: React.ChangeEvent<{}>, newValue: number): void => {
    setTab(newValue);
  };

  useEffect(() => {
    setSubAccountCategories([]);

    const fetchDataByTab = async () => {
      try {
        let data;
        switch (tab) {
          // case 0:
          //   data = await getAccountTax();
          //   break;
          case 0:
            data = await getAccountPassiva();
            break;
          case 1:
            data = await getAccountLoan();
            break;
          case 2:
            data = await getAccountCapitalInvestment();
            break;
          case 3:
            data = await getAccountOtherIncome();
            break;
          case 4:
            data = await getSalesDeposite();
            break;
          default:
            return;
        }
        setSubAccountCategories(data.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchDataByTab();
  }, [tab]);

  // const getAccountTax = async () => axios.get(`${ACCOUNT_CATEGORY_BASE_URL}/tax`, { cancelToken });
  const getAccountPassiva = async () => axios.get(`${ACCOUNT_CATEGORY_BASE_URL}/passiva`, { cancelToken });
  const getAccountLoan = async () => axios.get(`${ACCOUNT_CATEGORY_BASE_URL}/loan`, { cancelToken });
  const getAccountCapitalInvestment = async () => axios.get(`${ACCOUNT_CATEGORY_BASE_URL}/capital-investment`, { cancelToken });
  const getAccountOtherIncome = async () => axios.get(`${ACCOUNT_CATEGORY_BASE_URL}/other-income`, { cancelToken });
  const getSalesDeposite = async () => axios.get(`${ACCOUNT_CATEGORY_BASE_URL}/sales-deposit`, { cancelToken });

  const reMounted = () => {
    setIsSubmit(false);
  };

  const handleCloseCreates = () => {
    reMounted();
    handleCloseCreate();
  };

  return (
    <Dialog maxWidth={'sm'} disableBackdropClick={true} aria-labelledby='customized-dialog-title' open={open}>
      <DialogTitle>
        <Grid xs={12} container justify='space-between'>
          <Typography variant='h5'> Pemasukan Lain</Typography>
          <IconButton onClick={handleCloseCreates} size='small'>
            <Close />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container justify='flex-start' item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Grid container className={classes.tabPanel}>
            <Tabs value={tab} indicatorColor='primary' textColor='primary' onChange={handleTabs} aria-label='tab-produk'>
              {/* <Tab
                icon={
                  <Tooltip title='Pendapatan Bunga' placement='top'>
                    <AttachMoneyIcon />
                  </Tooltip>
                }
                className={classes.tab}
              /> */}
              <Tab
                icon={
                  <Tooltip title='Penjualan Activa' placement='top'>
                    <AccountBalanceWalletOutlinedIcon />
                  </Tooltip>
                }
                className={classes.tab}
              />
              <Tab
                icon={
                  <Tooltip title='Pinjaman' placement='top'>
                    <AssignmentOutlinedIcon />
                  </Tooltip>
                }
                className={classes.tab}
              />
              <Tab
                icon={
                  <Tooltip title='Penanaman Modal' placement='top'>
                    <ArtTrackOutlinedIcon />
                  </Tooltip>
                }
                className={classes.tab}
              />
              <Tab
                icon={
                  <Tooltip title='Penerimaan Lain' placement='top'>
                    <BallotOutlinedIcon />
                  </Tooltip>
                }
                className={classes.tab}
              />
              <Tab
                icon={
                  <Tooltip title='Panjar Penjualan' placement='top'>
                    <CardTravelOutlinedIcon />
                  </Tooltip>
                }
                className={classes.tab}
              />
            </Tabs>
          </Grid>
        </Grid>

        {/* {tab === 0 && (
          <CreateTax
            financialAccounts={financialAccounts}
            subAccountCategories={subAccountCategories}
            handleCloseCreate={handleCloseCreate}
            reFetchData={reFetchData}
            handleSnackBar={handleSnackBar}
          />
        )} */}

        {tab === 0 && (
          <CreateAssetSale
            financialAccounts={financialAccounts}
            subAccountCategories={subAccountCategories}
            open={open}
            handleCloseCreate={handleCloseCreate}
            reFetchData={reFetchData}
            handleSnackBar={handleSnackBar}
          />
        )}

        {tab === 1 && (
          <CreateLoan
            financialAccounts={financialAccounts}
            subAccountCategories={subAccountCategories}
            open={open}
            handleCloseCreate={handleCloseCreate}
            reFetchData={reFetchData}
            handleSnackBar={handleSnackBar}
          />
        )}

        {tab === 2 && (
          <CreateCapitalInvestment
            financialAccounts={financialAccounts}
            subAccountCategories={subAccountCategories}
            open={open}
            handleCloseCreate={handleCloseCreate}
            reFetchData={reFetchData}
            handleSnackBar={handleSnackBar}
          />
        )}

        {tab === 3 && (
          <CreateOtherIncome
            financialAccounts={financialAccounts}
            subAccountCategories={subAccountCategories}
            open={open}
            handleCloseCreate={handleCloseCreate}
            reFetchData={reFetchData}
            handleSnackBar={handleSnackBar}
          />
        )}
        {tab === 4 && (
          <CreateSalesDeposit
            financialAccounts={financialAccounts}
            subAccountCategories={subAccountCategories}
            open={open}
            handleCloseCreate={handleCloseCreate}
            reFetchData={reFetchData}
            handleSnackBar={handleSnackBar}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default memo(OtherIncomeCreate);
